// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as ComposioRouteImport } from './routes/composio'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as HierarchyRouteImport } from './routes/hierarchy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MemoryRouteImport } from './routes/memory'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as VaultRouteImport } from './routes/vault'
import { Route as WorkspacesRouteImport } from './routes/workspaces'
import { Route as RegistryKindRouteImport } from './routes/registry.$kind'
import { Route as TerminalSessionIdRouteImport } from './routes/terminal.$sessionId'
import { Route as VaultApprovalsRouteImport } from './routes/vault.approvals'
import { Route as VaultAuditRouteImport } from './routes/vault.audit'
import { Route as VaultDaemonsRouteImport } from './routes/vault.daemons'
import { Route as VaultFilesRouteImport } from './routes/vault.files'
import { Route as VaultMessagesRouteImport } from './routes/vault.messages'
import { Route as VaultPrincipalsRouteImport } from './routes/vault.principals'
import { Route as VaultProjectsRouteImport } from './routes/vault.projects'
import { Route as VaultTenantKeyRouteImport } from './routes/vault.tenant-key'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AlertsRoute = AlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => rootRouteImport
          })
const ComposioRoute = ComposioRouteImport.update({
            id: '/composio',path: '/composio',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const HierarchyRoute = HierarchyRouteImport.update({
            id: '/hierarchy',path: '/hierarchy',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MemoryRoute = MemoryRouteImport.update({
            id: '/memory',path: '/memory',getParentRoute: () => rootRouteImport
          })
const ProjectsRoute = ProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => rootRouteImport
          })
const SessionsRoute = SessionsRouteImport.update({
            id: '/sessions',path: '/sessions',getParentRoute: () => rootRouteImport
          })
const VaultRoute = VaultRouteImport.update({
            id: '/vault',path: '/vault',getParentRoute: () => rootRouteImport
          })
const WorkspacesRoute = WorkspacesRouteImport.update({
            id: '/workspaces',path: '/workspaces',getParentRoute: () => rootRouteImport
          })
const RegistryKindRoute = RegistryKindRouteImport.update({
            id: '/registry/$kind',path: '/registry/$kind',getParentRoute: () => rootRouteImport
          })
const TerminalSessionIdRoute = TerminalSessionIdRouteImport.update({
            id: '/terminal/$sessionId',path: '/terminal/$sessionId',getParentRoute: () => rootRouteImport
          })
const VaultApprovalsRoute = VaultApprovalsRouteImport.update({
            id: '/approvals',path: '/approvals',getParentRoute: () => VaultRoute
          })
const VaultAuditRoute = VaultAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => VaultRoute
          })
const VaultDaemonsRoute = VaultDaemonsRouteImport.update({
            id: '/daemons',path: '/daemons',getParentRoute: () => VaultRoute
          })
const VaultFilesRoute = VaultFilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => VaultRoute
          })
const VaultMessagesRoute = VaultMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => VaultRoute
          })
const VaultPrincipalsRoute = VaultPrincipalsRouteImport.update({
            id: '/principals',path: '/principals',getParentRoute: () => VaultRoute
          })
const VaultProjectsRoute = VaultProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => VaultRoute
          })
const VaultTenantKeyRoute = VaultTenantKeyRouteImport.update({
            id: '/tenant-key',path: '/tenant-key',getParentRoute: () => VaultRoute
          })





const VaultRouteChildren = {
  VaultApprovalsRoute: VaultApprovalsRoute,VaultAuditRoute: VaultAuditRoute,VaultDaemonsRoute: VaultDaemonsRoute,VaultFilesRoute: VaultFilesRoute,VaultMessagesRoute: VaultMessagesRoute,VaultPrincipalsRoute: VaultPrincipalsRoute,VaultProjectsRoute: VaultProjectsRoute,VaultTenantKeyRoute: VaultTenantKeyRoute
}

const VaultRouteWithChildren = VaultRoute._addFileChildren(VaultRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AlertsRoute: AlertsRoute,ComposioRoute: ComposioRoute,DashboardRoute: DashboardRoute,HierarchyRoute: HierarchyRoute,LoginRoute: LoginRoute,MemoryRoute: MemoryRoute,ProjectsRoute: ProjectsRoute,SessionsRoute: SessionsRoute,VaultRoute: VaultRouteWithChildren,WorkspacesRoute: WorkspacesRoute,RegistryKindRoute: RegistryKindRoute,TerminalSessionIdRoute: TerminalSessionIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)